import net from "App/net";

var DiagnosticsFoulingClient = function () { };

DiagnosticsFoulingClient.prototype.getDiagnostics = function (vesselId) {
  return net.get(`/diagnostics/Fouling`, { vesselId: vesselId });
};

export default new DiagnosticsFoulingClient();
